import React from "react";
import Svg, { Path, Circle } from "react-native-svg";
const AddContact = (props) => (
  <Svg
    width="26"
    height="19"
    viewBox="0 0 26 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      d="M16.4091 9.625C18.9205 9.625 20.9545 7.52734 20.9545 4.9375C20.9545 2.34766 18.9205 0.25 16.4091 0.25C13.8977 0.25 11.8636 2.34766 11.8636 4.9375C11.8636 7.52734 13.8977 9.625 16.4091 9.625ZM6.18182 7.28125V4.9375C6.18182 4.29297 5.67045 3.76562 5.04545 3.76562C4.42045 3.76562 3.90909 4.29297 3.90909 4.9375V7.28125H1.63636C1.01136 7.28125 0.5 7.80859 0.5 8.45312C0.5 9.09766 1.01136 9.625 1.63636 9.625H3.90909V11.9688C3.90909 12.6133 4.42045 13.1406 5.04545 13.1406C5.67045 13.1406 6.18182 12.6133 6.18182 11.9688V9.625H8.45455C9.07955 9.625 9.59091 9.09766 9.59091 8.45312C9.59091 7.80859 9.07955 7.28125 8.45455 7.28125H6.18182ZM16.4091 11.9688C13.375 11.9688 7.31818 13.5391 7.31818 16.6562V17.8281C7.31818 18.4727 7.82955 19 8.45455 19H24.3636C24.9886 19 25.5 18.4727 25.5 17.8281V16.6562C25.5 13.5391 19.4432 11.9688 16.4091 11.9688Z"
      fill="black"
      fill-opacity="0.8"
    />
  </Svg>
);

export default AddContact;
